import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import * as RegValidators from 'src/app/shared/reactive-validators/fields.validator';
import { FormFunctions } from '../../form-functions';
import { ContinueBtnHoverTxt } from 'src/app/shared/common/common-constants';
import { ClassificationSerachInfo, ClassificationUnit } from 'src/app/store/feature-stores/classification-search-store/models/classification-unit';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { CommonFunctions } from 'src/app/shared/common/common-functions';
import { Subscription } from 'rxjs';

@Injectable()
export class ClassificationSearchViewCoreFunctions {
  subscriptions: Subscription[] = [];
  
  numberOfProductDetails = 0;
  totalPercentage: number = null;
  subDescription1: Subscription;
  subPercentage1: Subscription;
  subDescription2: Subscription;
  subPercentage2: Subscription;
  subDescription3: Subscription;
  subPercentage3: Subscription;

  classificationUnits?: ClassificationUnit[];
  
  clickSearchButtonToProceedErrorMessage = 'Please click the \'Search\' button to proceed.';
  summaryOfOperationsInvalidMsg = 'Please enter a description of the business operations in B.C.';
  summaryOfOperationsMinCharsMsg = 'Please enter at least 4 characters the description of the business operations in B.C.';
  productOrServiceInvalidMsg = "Please enter at least 1 character.";
  percentageInvalidMsg = "Please enter a percentage.";
 
  listProductDetails = [   
    { id: 1, description: 'description1', percentage: 'percentage1' },
    { id: 2, description: 'description2', percentage: 'percentage2' },
    { id: 3, description: 'description3', percentage: 'percentage3' },
  ];

  
  multipleStreamsFields = {    
    hasMultipleRevenueStreams: new UntypedFormControl('', [Validators.required])
  }

  productDetails1Fields = {    
    description1: new UntypedFormControl('',[Validators.required, RegValidators.requiredValidator(this.productOrServiceInvalidMsg)]),
    percentage1: new UntypedFormControl('', [Validators.required, Validators.min(0), Validators.max(100), RegValidators.requiredValidator(this.percentageInvalidMsg)])
  }
  productDetails2Fields = {
    description2: new UntypedFormControl('',[Validators.required, RegValidators.requiredValidator(this.productOrServiceInvalidMsg)]),
    percentage2: new UntypedFormControl('', [Validators.required, Validators.min(0), Validators.max(100), RegValidators.requiredValidator(this.percentageInvalidMsg)])
  }
  productDetails3Fields = {
    description3: new UntypedFormControl('',[Validators.required, RegValidators.requiredValidator(this.productOrServiceInvalidMsg)]),
    percentage3: new UntypedFormControl('', [Validators.required, Validators.min(0), Validators.max(100), RegValidators.requiredValidator(this.percentageInvalidMsg)])
  }

  classificationSearchFields = {      
    classificationUnit: new UntypedFormControl('', [Validators.required]),
    classificationUnitScore: new UntypedFormControl(''),
    noMatchingClassificationUnitsFound: new UntypedFormControl(''),
    searchButtonClicked: new UntypedFormControl(''),
    searchKey: new UntypedFormControl('',  [RegValidators.requiredAndMinCharValidator(this.summaryOfOperationsInvalidMsg, 4,this.summaryOfOperationsMinCharsMsg)])
  };  

  constructor(     
    private formFunctions: FormFunctions,
    private commonFunctions: CommonFunctions,
    private sessionStorageService: SessionStorageService) {  }

    public createClassificationSearchForm(formGroup: UntypedFormGroup) {   
      try
      {      
        this.formFunctions.addFormFields(this.multipleStreamsFields, formGroup);
        this.formFunctions.addFormFields(this.classificationSearchFields, formGroup);
        
        this.subscriptions.push(
          formGroup.get('searchKey').valueChanges.subscribe(value => {
            setTimeout(() => {             
              formGroup.controls.searchButtonClicked.setValue(null);            
            });
          })
        );        
      } catch(ex) {
        console.log('[ClassificationSearchViewCoreFunctions] createClassificationSearchForm ex=' + ex.message);
      }    
    }  

  public updateSubscribeProductionAndService(isSubscribe: boolean, formGroup: UntypedFormGroup, 
    description: string, percentage: string, 
    subDescription: Subscription, subPercentage: Subscription) {    
    try {    
      if (isSubscribe) {
        subDescription = formGroup.get(description).valueChanges.subscribe(value => {
          setTimeout(() => {            
            formGroup.controls.searchButtonClicked.setValue(null);            
          });
        });

        subPercentage = formGroup.get(percentage).valueChanges.subscribe(value => {
          setTimeout(() => {            
            formGroup.controls.searchButtonClicked.setValue(null);            
          });
        });

      } else {
        subDescription.unsubscribe();
        subPercentage.unsubscribe();        
      }     
      
    } catch(ex) {
      console.log('[ClassificationSearchViewCoreFunctions] updateSubscribeProductionAndService ex=' + ex.message);
    }  
  }

  public unsubscribeAll() {    
    try {
      if (this.subscriptions && this.subscriptions.length > 0) {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
      }   

      this.subDescription1?.unsubscribe();
      this.subPercentage1?.unsubscribe();
      this.subDescription2?.unsubscribe();
      this.subPercentage2?.unsubscribe();
      this.subDescription3?.unsubscribe();
      this.subPercentage3?.unsubscribe();

    } catch(ex) {
      console.log('[ClassificationSearchViewCoreFunctions] unsubscribeAll ex=' + ex.message);
    }  

  }

  public getSearchPayload(formGroup: UntypedFormGroup, irRefNumber: string, searchByML: string) {    
    const businessSummary = this.getFormControlValue(formGroup.controls.searchKey);  
    let descriptions = this.getFormControlValue(formGroup.controls.description1) + 
          ' ' + this.getFormControlValue(formGroup.controls.description2) +
          ' ' + this.getFormControlValue(formGroup.controls.description3);
    descriptions = descriptions.trim();
    var mergedClassificationPredictionPayload = {
      payload: {
        businessDescription: businessSummary,
        productsServices: descriptions,        
        irRefNumber: irRefNumber,
        searchByML: searchByML
      }};  
    return mergedClassificationPredictionPayload;
  }  

  public getTotalPercentage(formGroup: UntypedFormGroup): number {
    let total = 0;
    try {
      total = this.getFormControlValueNumber(formGroup.controls.percentage1) + 
          this.getFormControlValueNumber(formGroup.controls.percentage2) +
          this.getFormControlValueNumber(formGroup.controls.percentage3);
    }
    catch(ex) {
      console.log('[ClassificationSearchViewCoreFunctions] getTotalPercentage ex=' + ex);
    }
    return total;
  }

  public totalPercentageIsValid(formGroup: UntypedFormGroup) {
    const total = this.getTotalPercentage(formGroup);    
    return total == 100? true : false;
  }

  public getSaveClassificationPayload(formGroup: UntypedFormGroup) : ClassificationSerachInfo {    
    const selectedClassId = formGroup.controls.classificationUnit.value;  
    const selectedClass = this.getSelectedClassification(selectedClassId, this.classificationUnits);
    const selectedClassName = selectedClass.name;
    const selectedClassCode = selectedClass.classificationUnitCode;
    const classificationUnits = this.getClassificationPredictionPayload(selectedClassId, this.classificationUnits);    
    const payload = {   
      classificationId: selectedClassId,
      classificationUnitCode: selectedClassCode,
      classificationName: selectedClassName,
      classificationUnits: classificationUnits,
      businessOperationsDesc: this.getFormControlValue(formGroup.controls.searchKey),
      description1: this.getFormControlValue(formGroup.controls.description1),
      percentage1: this.getFormControlValue(formGroup.controls.percentage1),
      description2: this.getFormControlValue(formGroup.controls.description2),
      percentage2: this.getFormControlValue(formGroup.controls.percentage2),
      description3: this.getFormControlValue(formGroup.controls.description3),
      percentage3: this.getFormControlValue(formGroup.controls.percentage3),
      hasMultipleRevenueStreams: this.getFormControlValue(formGroup.controls.hasMultipleRevenueStreams),
    };
    return payload;
  }  

  
  public addProductDetails(index: number, formGroup: UntypedFormGroup) {      
    try {       
      if (index === 2) {
        this.formFunctions.addFormFields(this.productDetails2Fields, formGroup);         
        this.updateSubscribeProductionAndService(true, formGroup, 'description' + index, 'percentage' + index, this.subDescription2, this.subPercentage2);
      }      

      if (index === 3) {
        this.formFunctions.addFormFields(this.productDetails3Fields, formGroup); 
        this.updateSubscribeProductionAndService(true, formGroup, 'description' + index, 'percentage' + index, this.subDescription3, this.subPercentage3);
      }

      const listConstrols = [
        {name:  'description' + index, value:''},
        {name: 'percentage' + index, value:''}
      ];

      this.clearFormValues(listConstrols, formGroup);        

    } catch(ex) {
      console.log('[ClassificationSearchViewCoreFunctions] addProductDetails ex=' + ex.message);
    }              
  }

  private removeProductDetailsByIndex(index: number, formGroup: UntypedFormGroup) {      
    try {  
      const item = this.listProductDetails[index-1];  
      this.setFormValue(formGroup, item.description, '');
      this.setFormValue(formGroup, item.percentage, '');  

      if (index === 2) {       
        this.updateSubscribeProductionAndService(false, formGroup, item.description, item.percentage, this.subDescription2, this.subPercentage2);
        this.formFunctions.removeFormFields(this.productDetails2Fields, formGroup);         
      }      

      if (index === 3) {               
        this.updateSubscribeProductionAndService(false, formGroup, item.description, item.percentage, this.subDescription3, this.subPercentage3);
        this.formFunctions.removeFormFields(this.productDetails3Fields, formGroup);  
      }
      
    } catch(ex) {
      console.log('[ClassificationSearchViewCoreFunctions] removeProductDetails ex=' + ex.message);
    }              
  } 

  public loadButtonHoverText(formGroup: UntypedFormGroup): string {
    let continueButtonHoverText = '';
    if (formGroup.controls.searchButtonClicked?.value !== 'Y') {
      continueButtonHoverText = this.clickSearchButtonToProceedErrorMessage;
    } else {
      continueButtonHoverText =
      formGroup.controls.classificationUnit &&
      formGroup.controls.classificationUnit.invalid ? ContinueBtnHoverTxt : '';
    }
    return continueButtonHoverText;
  }

  public isFormValid(formGroup: UntypedFormGroup, log: boolean, caller: string): string {
    let message = '';
    let isValid = false;
    const totalPercentageIsValidValue = this.totalPercentageIsValid(formGroup);
    const isSearchButtonClickedValue = this.isSearchButtonClicked(formGroup);
    const classificationUnitIsValidValue = formGroup.controls.classificationUnit?.valid;
    const hasMultipleRevenueStreams = formGroup.controls.hasMultipleRevenueStreams?.value;
    if (formGroup.valid && 
      isSearchButtonClickedValue &&
        classificationUnitIsValidValue &&
        (hasMultipleRevenueStreams ==='Y' && totalPercentageIsValidValue || hasMultipleRevenueStreams ==='N')) {
      isValid = true;
    }  

    if (!isValid) {
      message = message + ' totalPercentageIsValid=' + totalPercentageIsValidValue + ', ';
      message = message + ' isSearchButtonClicked=' + isSearchButtonClickedValue + ', ';
      message = message + ' classificationUnitIsValid=' + classificationUnitIsValidValue + ', ';
      message = message + ' hasMultipleRevenueStreams=' + hasMultipleRevenueStreams + ', ';
      if (log) {
        message = message + ' caller=' + caller +' formGroup invalid. details=' + this.getFormGroupValidDetails(formGroup);
      }
    }
    
    return message;
  }

  public getSelectClassificationUnitDesc(formGroup: UntypedFormGroup, selectedClassId: any = null) {
    let display = '';
    if (this.isSearchButtonClicked(formGroup)) {    
      if (selectedClassId == null) {
        selectedClassId=  formGroup.controls.classificationUnit.value;
      }
      const selectedClass = this.getSelectedClassification(selectedClassId, this.classificationUnits);
      display = selectedClass && selectedClass.classId > 0 ? selectedClass?.name : '';
    }        
    return display;   
  }

  public isClassificationUnitRelatedToVehicle(formGroup: UntypedFormGroup, selectedClassId: any = null) {
    let isVehicleCu = false;
    if (this.isSearchButtonClicked(formGroup)) {  
      if (selectedClassId == null) {
        selectedClassId=  formGroup.controls.classificationUnit?.value;
      }
      const selectedClass = this.getSelectedClassification(selectedClassId, this.classificationUnits);
      if (selectedClass && selectedClass.classificationUnitCode > 0) {
        isVehicleCu = this.commonFunctions.isVehicleClassificationUnit(this.sessionStorageService, selectedClass.classificationUnitCode);      
      }
    }  
    return isVehicleCu;   
  }


  public getClassificationUnitsData(): ClassificationUnit[] {
    return this.classificationUnits;
  }

  public setClassificationUnitsData(classificationUnits: ClassificationUnit[]) {
    this.classificationUnits = classificationUnits;
  }
  
  public addNewClassificationUnit(classification: ClassificationUnit) {
    this.classificationUnits?.push(classification);
  }
  
  public isSearchButtonClicked(formGroup: UntypedFormGroup) {
    let isClicked = false;
    if (formGroup.controls.searchButtonClicked &&
        formGroup.controls.searchButtonClicked.value === 'Y') {
          isClicked = true;
    }
    return isClicked;
  }

  public setFormValue(formGroup: UntypedFormGroup, name: string, value: any, caller?: string) {    
    try{     
      let control = formGroup.get(name);
      if (control) {
        control.setValue(value); 
      }      
    } catch(ex) { 
      console.log('[ClassificationSearchViewCoreFunctions] setFormValue formGroup=' + formGroup + ' name=' + name + ' caller=' + caller + ' ex=' + ex.message);
    }        
  } 

  private getFormControlValue(control: any) {    
    let value = control?.value;
    if (value == null || value == undefined) {
      value = '';
    }

    value = value.trim();
    return value;
  }  

  private getFormControlValueNumber(control: any) {    
    let valueInt = 0;
    try
    {
      let value = control?.value;
      if (value === null) {
        value = '';
      }

      if (value !== null && value == undefined) {
        value = '';
      }

      value = value?.trim();
      if (value != '') {
        valueInt = parseInt(value); 
      }
      
    } catch(ex) { 
      console.log('[ClassificationSearchViewCoreFunctions] getFormControlValueNumber ex=' + ex.message);
    }  
    return valueInt;
  }  

  private getClassificationPredictionPayload(selectedClassId: any, mlSearchResponse: ClassificationUnit[]): any {    
   
    let cus= mlSearchResponse;
    let finalList = [];
    if (cus != null){
      cus.forEach(cu => {     
        if (this.isValidClassificationUnit(cu)) {
          finalList.push(
            {           
              classId : cu.classId,
              score: cu.score,
              classificationUnitCode: cu.classificationUnitCode,
              selected: selectedClassId == cu.classId? true: false,
              mlSearch: cu.mlSearch
            }
          ); 
        }   
             
      });
    }
    const classificationPrediction = finalList;   
    return classificationPrediction;
  }
  
  isValidClassificationUnit(cu: any) {
    let valid = false;
    try {
      if (cu != null && cu.classId != null ) {
        const classId = Number.parseInt(cu.classId);
        if (classId > 0) {
          valid = true;
        }
      }      
    } catch (ex) {                
      const errroMessage = '[ClassificationSearchViewCoreFunctions] isValidClassificationUnit ex=' + ex.message;
      console.log(errroMessage);
    }
    return valid;
  }

  private getSelectedClassification(selectedClassId: any, mlSearchResponse: ClassificationUnit[]): ClassificationUnit {    
    let cu = new ClassificationUnit();
    cu.classId = 0;  
    cu.name = '';  
    cu.classificationUnitCode = 0;  

    var cus= mlSearchResponse;  
    if (cus !=null) {
      const find = cus.find(c=>c.classId ==selectedClassId);
      if (find) {
        cu.classId = find.classId;  
        cu.name = find.name;  
        cu.classificationUnitCode = find.classificationUnitCode;  
      }      
    } 
    return  cu;
  }   
  
  getCuIdFromIreg(internetRegistration: any) {
    let cuId =  0; 
    try {
      if (internetRegistration.classification != null &&
        internetRegistration.classification.classificationSummary != null &&
        this.isValidClassificationUnitId(internetRegistration.classification.classificationSummary.finalClassificationUnit)) {       
            cuId = internetRegistration.classification.classificationSummary.finalClassificationUnit;  
    }     
    } catch (ex) { 
      console.log('getCuIdFromIreg ex=' + ex.message);
    }
    return cuId;
  }

  isValidClassificationUnitId(value: any) {
    let valid = false;
    try {
      if (value != null) {
        const classId = Number.parseInt(value);
        if (classId > 0) {
          valid = true;
        }
      }      
    } catch (ex) {
      console.log('isValidClassificationUnitId ex=' + ex.message);
    }
    return valid;
  }

  clearFormValues(listConstrols: any, formGroup: UntypedFormGroup) {   
    try {         

      listConstrols.forEach((item) => {      
        const control = formGroup.get(item.name);
        control?.setValue(item.value);
        control?.markAsTouched();
        control?.reset();
      });
    
    }
    catch(ex) {
      console.log(' clearFormValues ex=' + ex.message);
    } 
  }

  
  public getFormGroupValidDetails(formGroup: UntypedFormGroup): string {
    let result = ''; 
    try {
        Object.keys(formGroup.controls).forEach(key => {         
          if (formGroup.controls[key] && formGroup.controls[key].invalid) {
            result = result + ', ' + key;
          }
        });
    } catch (ex) {
      console.log('getFormGroupValidDetails: ex=' + ex.message);
    }       
    return result;
  }

  private getFormControl(formGroup: UntypedFormGroup, name: string, caller?: string): any {
    let control = null;   
    try {
      control = formGroup.get(name);
    } catch(ex) { 
      console.log('getFormControl formGroup=' + formGroup + ' name=' + name + ' ex=' + ex.message + ' caller=' + caller);
    }     
    return control;
  }

  onHasMultipleRevenueStreamsChange(value: string, formGroup: UntypedFormGroup) {    
    console.log(' onHasMultipleRevenueStreamsChange value=' + value);   
    try {  
       
        let listConstrols = []; 
        this.listProductDetails.forEach((item) => {      
          listConstrols.push({name: item.description, value:''});
          listConstrols.push({name: item.percentage, value:''});
        });  
        const item1 = this.listProductDetails[0]; 

        if (value === 'Y') {    
          this.numberOfProductDetails = 1;  
          this.formFunctions.addFormFields(this.productDetails1Fields, formGroup);  
          this.clearFormValues(listConstrols, formGroup);       
          this.updateSubscribeProductionAndService(true,  formGroup, item1.description, item1.percentage, this.subDescription1, this.subPercentage1);
        } else {
          this.clearFormValues(listConstrols, formGroup); 
          this.numberOfProductDetails = 0; 

           // reset additional product details
          const item3 = this.listProductDetails[2]; 
          this.updateSubscribeProductionAndService(false,  formGroup, item3.description, item3.percentage, this.subDescription1, this.subPercentage1); 
          this.formFunctions.removeFormFields(this.productDetails3Fields, formGroup); 
          
          const item2 = this.listProductDetails[1]; 
          this.updateSubscribeProductionAndService(false,  formGroup, item2.description, item2.percentage, this.subDescription1, this.subPercentage1); 
          this.formFunctions.removeFormFields(this.productDetails2Fields, formGroup); 

          // reset first product details
          this.updateSubscribeProductionAndService(false,  formGroup, item1.description, item1.percentage, this.subDescription1, this.subPercentage1); 
          this.formFunctions.removeFormFields(this.productDetails1Fields, formGroup);  

        }  
       
    } catch (ex) {
      console.log('onHasMultipleRevenueStreamsChange: ex=' + ex.message);
    }      
  } 

  private getBusinessActivities(formGroup: UntypedFormGroup, internetRegistration: any) {
    try {

      const hasMultipleRevenueStreams = internetRegistration.hasMultipleRevenueStreams;
      formGroup.controls.hasMultipleRevenueStreams.setValue(hasMultipleRevenueStreams); 
      this.onHasMultipleRevenueStreamsChange(hasMultipleRevenueStreams, formGroup);

      if (hasMultipleRevenueStreams ==='Y') {
        let businessActivities = null;
        if ( internetRegistration.eligibility != null && internetRegistration.eligibility.eligibilityResponseBusinessOperation != null ) {   
          businessActivities = internetRegistration.eligibility.eligibilityResponseBusinessOperation.productsServicesDescriptionText;
  
          const item1 = this.listProductDetails[0];  
          const description1 = this.getFormControl(formGroup, item1.description);
          const percentage1 = this.getFormControl(formGroup, item1.percentage);

          let productsServices = businessActivities !=null ? businessActivities.split('^'): null;  
          if (productsServices != null && productsServices.length == 6) {
            description1?.setValue(productsServices[0]);      
            percentage1?.setValue(productsServices[1]);
            percentage1?.markAsTouched();
            
            if (productsServices[2] != null && productsServices[2] != '') {
              this.addNewProductDetails(formGroup);

              const item2 = this.listProductDetails[1];  
              const description2 = this.getFormControl(formGroup, item2.description);
              const percentage2 = this.getFormControl(formGroup, item2.percentage);

              description2?.setValue(productsServices[2]);
              percentage2?.setValue(productsServices[3]);
              percentage2?.markAsTouched();
            }      
          
      
            if (productsServices[4] != null && productsServices[4] != '') {
              this.addNewProductDetails(formGroup);
              const item3 = this.listProductDetails[2];  
              const description3 = this.getFormControl(formGroup, item3.description);
              const percentage3 = this.getFormControl(formGroup, item3.percentage);

              description3?.setValue(productsServices[4]);
              percentage3?.setValue(productsServices[5]);
              percentage3?.markAsTouched();
            }      
           
          } else {            
            description1?.setValue(null);   
            description1?.markAsUntouched();
            description1?.reset();
    
            percentage1?.setValue(null);
            percentage1?.markAsUntouched();
            percentage1?.reset();        
          } 
        }     
      }     
    }
    catch(ex) {
      console.log('[Classification Search] getBusinessActivities ex=' + ex);
    } 
  }  


  addNewProductDetails(formGroup: UntypedFormGroup) {
    if (this.numberOfProductDetails <= 3) {
      this.numberOfProductDetails++;
      let index = 0;
      if (this.numberOfProductDetails === 2) {          
        index = 2;
      }

      if (this.numberOfProductDetails === 3) {
        index = 3;
      }

      if (index != 0 ) {
        this.addProductDetails(index, formGroup); 
        formGroup.controls.searchButtonClicked.setValue(null); 
      }
    }  
  }

  removeProductDetails(index: number, formGroup: UntypedFormGroup){     
    this.removeProductDetailsByIndex(index, formGroup);
    if (index >=1) { 
      formGroup.controls.searchButtonClicked.setValue(null); 
      this.removeProductDetailsByIndex(index, formGroup); 
      this.numberOfProductDetails = index -1;      
    }  
  }

  public getBusinessData(formGroup: UntypedFormGroup, internetRegistration: any) {   
    try {  
      if ( internetRegistration.participation[0] !=null && 
              internetRegistration.participation[0].regLegalEntity !=null &&
              internetRegistration.participation[0].regLegalEntity.item !=null &&
              internetRegistration.participation[0].regLegalEntity.item.contactDescription1 != null ) {     
            formGroup.controls.searchKey.setValue(internetRegistration.participation[0].regLegalEntity.item.contactDescription1);  
      } else {
        formGroup.controls.searchKey.setValue('');
        formGroup.controls.searchKey.markAsUntouched();
        formGroup.controls.searchKey.reset();
        console.log('[Classification Search] getBusinessData init searchKey. markAsUntouched');
      }

      if ( internetRegistration != null ) { 
        this.getBusinessActivities(formGroup, internetRegistration);
      }         
    }
    catch(ex) {
      console.log('[Classification Search] getBusinessData ex=' + ex);
    }  
  }


  
  disableSearch(formGroup: UntypedFormGroup): boolean {    
    const item1 = this.listProductDetails[0];  
    const description1 = this.getFormControl(formGroup, item1.description);
    const percentage1 = this.getFormControl(formGroup, item1.percentage);

    const item2 = this.listProductDetails[1];  
    const description2 = this.getFormControl(formGroup, item2.description);
    const percentage2 = this.getFormControl(formGroup, item2.percentage);

    const item3 = this.listProductDetails[2];  
    const description3 = this.getFormControl(formGroup, item3.description);
    const percentage3 = this.getFormControl(formGroup, item3.percentage);

    let valid = formGroup.controls.searchKey.valid && 
                description1?.valid && percentage1?.valid && 
                this.totalPercentageIsValid(formGroup);
        
    if (valid && description2) {
      valid = valid && description2?.valid && percentage2?.valid;
    }
    if (valid && description3) {
      valid = valid && description3?.valid&&percentage3?.valid;
    } 

    if (percentage1 && percentage1.touched ||
        percentage2 && percentage2.touched ||
        percentage3 && percentage3.touched ) {
      this.totalPercentage = this.getTotalPercentage(formGroup);
    }

    if (!valid) {
      if (formGroup.controls.hasMultipleRevenueStreams.value === 'N' && formGroup.controls.searchKey.valid) {
        valid = true;
      }
    }
    return !valid;
  }

}
